import * as styles from './index.module.scss';

const HeroTags = () => (
  <div className={styles['tags-container']}>
    <div className={styles['tag']}>Repair</div>
    <div className={styles['dot-divider']}>•</div>
    <div className={styles['tag']}>Install</div>
    <div className={styles['dot-divider']}>&bull;</div>
    <div className={styles['tag']}>Replace</div>
  </div>
);

export default HeroTags;
